import { useState } from "react";

interface IDocument {
  [type: string]: any;
}
interface IProps {
  statusObj: {
    pending: number;
    accepted: number;
    rejected: number;
    [type: string]: any;
  };
  document: IDocument;
  documentIndex: number;
}
const ApprovalSelect = ({
  statusObj,
  document,
  documentIndex,
}: IProps) => {

  const [render, setRender] = useState(false);

  return (
    <>
      <select
        style={{
          fontSize: '1.2rem',
          outline: 'none',
          border: 'none',
          padding: '5px',
          marginLeft: '0.5rem',
          width: '150px',
          textAlign: 'center',
          textTransform: 'capitalize',
          ...(document.status === 'pending' && {
            backgroundColor: '#FDD835',
          }),
          ...(document.status === 'accepted' && {
            backgroundColor: '#2b8a3e',
            color: '#fff',
          }),
          ...(document.status === 'rejected' && {
            backgroundColor: '#f03e3e',
            color: '#fff',
          }),
        }}
        name="status"
        value={
          document?.status || ''
        }
        onChange={(e) => {
          document.status = e.target.value;
          setRender((prev) => !prev);
        }}
      >
        <option value="pending">PENDING</option>
        <option value="accepted">APPROVE</option>
        <option value="rejected">SEND BACK</option>
      </select>
    </>
  );
};

export default ApprovalSelect;
